export const formatCurrency = (amount) => amount ? new Intl.NumberFormat(
    'ru-RU',
    { style: 'currency', currency: 'KZT', currencyDisplay: 'narrowSymbol' }
  ).format(amount) : null
export const formatNumber = (amount) => new Intl.NumberFormat('ru-RU', { style: 'decimal'}).format(amount)